import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  gatewayFormValidatorWithCustomErrors,
  VALIDATORS,
} from "../../../../utils/gatewayFormValidator";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import QRCodeCard from "../../../../utils/QrCodeCard";
import {
  updateDepositAmount,
  createDeposit,
  getOneGateway,
} from "../../../../redux/user/actions";
import { APP_CONST } from "../../../../config/const";
import { Toaster } from "../../../../utils/toaster";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { getActiveBankDetails } from "../../../../redux/app/actions";
import CopyToClipboard from "react-copy-to-clipboard";
import BackIcon from "../../../../assets/svg/BackIcon";
import ArrowNext from "../../../../assets/images/arrow-next.png";

import { AiFillCopy } from "react-icons/ai";
import LeftBarSports from "../../../components/LeftBarSports";
import numberWithCommas from "../../../../utils/numbersWithComma";

import CrossBtn from "../../../../assets/images/icons/close_btn-icon.png";
import Youtube from "../../../../assets/images/youtube.png";
import AmountCard from "../../../components/gateways/AmountCard";
import DisplayValues from "../../../components/gateways/displayValues";

const CUSTOM_DEPOSIT_RESPONSE_TYPE = {
  QRCODE: "QRCODE",
  IMAGE: "IMAGE",
};

const DepositGateway = ({ activeGtw = null }) => {
  const [selectedGateway, setSelectedGateway] = useState(null);
  const { bankDetails } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const { gateway: gtw } = useParams();
  const gateway = activeGtw || gtw;
  const isBank = gateway === "bank_transfer";
  const showQrImg = selectedGateway?.qrCode !== null;
  const navigate = useNavigate();
  const [dAmount, setDAmount] = useState(null);
  const [customdepositResponseType, setCustomDepositResponseType] =
    useState(null);
  const [customActionDepositResponse, setCustomActionDepositResponse] =
    useState(null);
  const [isCreatingDeposit, setIsCreatingDeposit] = useState(false);

  const amountValues = [100, 200, 500, 1000, 5000, 10000, 50000];

  useEffect(() => {
    dispatch(getActiveBankDetails());
    if (gateway && gateway !== "bank_transfer" && typeof gateway === "string") {
      getOneGtwFromServer(gateway);
    }
  }, [gateway]);

  /**
   *
   * @param {string} gateway
   */
  const getOneGtwFromServer = async (gateway) => {
    const response = await getOneGateway(gateway);
    if (response && response?.data?.data?.data) {
      setSelectedGateway(response?.data?.data?.data);
    }
  };

  const validateData = (dataToValidate) => {
    const amountValidation = [];

    if (selectedGateway?.depositSettings?.min) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.min,
        type: VALIDATORS.Min,
        customMessage: `Min allowed amount is ${selectedGateway?.depositSettings?.min}`,
      });
    }

    if (selectedGateway?.depositSettings?.max) {
      amountValidation.push({
        validationValue: selectedGateway?.depositSettings?.max,
        type: VALIDATORS.Max,
        customMessage: `Max allowed amount is ${selectedGateway?.depositSettings?.max}`,
      });
    }

    let fields = selectedGateway?.fields;
    let validations = gatewayFormValidatorWithCustomErrors({
      fields: fields,
      dataToValidate: dataToValidate,
      cstmValidation: {
        amount: amountValidation,
      },
    });
    setErrors(validations);
    return validations;
  };

  const validateBankFormData = (data) => {
    const { amount, utrNo, txnImage } = data;
    let errorVar = {};
    if (!amount) {
      errorVar.amount = "Amount is required";
    }
    if (!utrNo) {
      errorVar.utrNo = "UTR is required";
    }
    if (!txnImage) {
      errorVar.txnImage = "Txn image is required";
    }
    setErrors(errorVar);
    return errorVar;
  };

  const handleChange = (e, type = "non-file") => {
    let name = e.target.name;
    let value = e.target.value;
    if (type === "file") {
      value = e.target.files?.[0];
    }
    let data = { ...formData, [name]: value };
    if (name === "amount") {
      setDAmount(value);
    }
    if (isBank) {
      validateBankFormData(data);
    } else {
      validateData(data);
    }

    setFormData(data);
  };

  const getIfDefaultValue = ({ data }) => {
    let updatedData = { ...data };
    selectedGateway?.fields.forEach((f) => {
      if (!Boolean(data[f?.accessor]) && Boolean(f?.value)) {
        updatedData[f?.accessor] = f?.value;
      }
    });
    return updatedData;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isBank) {
      if (Object.values(validateData({ ...formData })).length == 0) {
        setIsCreatingDeposit(true);
        if (
          selectedGateway?.fields.some(
            (f) => f?.accessor === "gateway" && f?.required === true,
          )
        ) {
          formData["gateway"] = selectedGateway?.code;
        }
        if (selectedGateway?.slug && selectedGateway?.slug !== null) {
          formData.slug = selectedGateway?.slug;
        }

        const dataWithDefaultValues = getIfDefaultValue({ data: formData });

        const response = await updateDepositAmount({
          data:
            selectedGateway?.url.indexOf("dynamicmanual") > -1
              ? {
                  amount: dataWithDefaultValues.amount,
                  slug: dataWithDefaultValues.slug,
                  dynamicFields: dataWithDefaultValues,
                }
              : dataWithDefaultValues,
          url: selectedGateway?.url,
          isMultiPart: selectedGateway?.fields.some(
            (f) => f?.type === "file" || f?.type === "image",
          ),
        });
        setIsCreatingDeposit(false);
        handleSubmitResponse(response);
      }
    } else {
      if (Object.values(validateBankFormData(formData)).length === 0) {
        setIsCreatingDeposit(true);
        createDeposit(formData)
          .then((res) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.SUCCESS, res.data.data.message);
          })
          .catch((err) => {
            setIsCreatingDeposit(false);
            Toaster(APP_CONST.TOAST_TYPE.ERROR, err.response.data.message);
          });
      }
    }
  };
  //TODO  Add it for url
  const handleSubmitResponse = (value) => {
    if (value) {
      if (
        selectedGateway?.url.indexOf("dynamicmanual") > -1 &&
        value?.data?.data
      ) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Request created");
        navigate("/cashier");
      }
      if (selectedGateway.type === "manual") {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, value.data.data.message);
      } else if (value?.data?.data?.data && "payUrl" in value?.data.data.data) {
        window.location.href = value?.data?.data?.data?.payUrl;
      } else if (
        value?.data?.data?.data &&
        "payImageUrl" in value?.data.data.data
      ) {
        // setPaymentImage(value?.data?.data?.data?.payImageUrl);
      } else if (selectedGateway.code === "alphapo") {
        window.location.href = value?.data?.data?.data?.url;
      }
      //  else if (selectedGateway.code === "floxypay") {
      //   window.location.href = value?.data.data.data?.payUrl;
      // } else if (selectedGateway.code === "coinbase") {
      //   window.location.href = value?.data.data.data?.payUrl;
      // } else if (selectedGateway.code === "binancepay") {
      //   window.location.href = value?.data.data.data?.payUrl;
      // }
    }
  };

  const renderFields = (field) => {
    switch (field.type) {
      case "file":
      case "image":
        return (
          <>
            <Form.Group
              className="mb-3 position-relative"
              controlId="formBasicUserName">
              <Form.Control
                type={"file"}
                placeholder={field.label}
                name={field.accessor}
                onChange={(e) => handleChange(e, "file")}
                style={{ display: !field.display ? "none" : "" }}
                isInvalid={!!errors[field.accessor]}
              />
              <Form.Control.Feedback type="invalid">
                {errors[field.accessor]}
              </Form.Control.Feedback>
            </Form.Group>
          </>
        );
      default:
        return (
          <>
            {selectedGateway?.type === "auto" &&
            field?.accessor === "amount" ? (
              <div className="mb-4">
                <ul className="select-amount">
                  <AmountCard
                    onClick={(amnt) => {
                      setDAmount(amnt);
                      setFormData({ ...formData, amount: amnt });
                    }}
                  />
                  <li className="fill-amount">
                    <Form.Group
                      className="position-relative"
                      controlId="formBasicUserName">
                      <Form.Control
                        type={field.type}
                        value={dAmount || ""}
                        placeholder={field.label}
                        name={field.accessor}
                        onChange={handleChange}
                        style={{ display: !field.display ? "none" : "" }}
                        isInvalid={!!errors[field.accessor]}
                      />
                      <span className="inr">&nbsp; &nbsp;</span>
                      <Form.Control.Feedback type="invalid">
                        {errors[field.accessor]}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </li>
                </ul>
              </div>
            ) : (
              <Form.Group
                className="mb-3 position-relative"
                controlId="formBasicUserName ">
                <Form.Control
                  type={field.type}
                  // value={dAmount || ""}
                  placeholder={
                    selectedGateway?.id === "lfaFF2tO" &&
                    field?.accessor === "refCode"
                      ? "Agent code"
                      : field.label
                  }
                  value={
                    !Boolean(formData?.[field?.accessor]) &&
                    formData?.[field?.accessor] !== "" &&
                    field?.value
                      ? field?.value
                      : formData?.[field?.accessor]
                  }
                  name={field.accessor}
                  onChange={handleChange}
                  style={{ display: !field.display ? "none" : "" }}
                  isInvalid={!!errors[field.accessor]}
                />
                <Form.Control.Feedback type="invalid">
                  {errors[field.accessor]}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </>
        );
    }
  };
  const phone = appDetails?.WHATS_APP_URL?.replace(/\D/g, "");

  const renderBankTransferForm = () => {
    return (
      <Form className="gatewayForm">
        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName">
          <Form.Control
            type={"number"}
            placeholder={"Enter amount"}
            name={"amount"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["amount"]}
          />
          <Form.Control.Feedback type="invalid">
            {errors["amount"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName">
          <Form.Control
            type={"text"}
            placeholder={"Enter UTR no"}
            name={"utrNo"}
            onChange={(e) => handleChange(e)}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["utrNo"]}
          />
          <Form.Control.Feedback type="invalid">
            {errors["utrNo"]}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group
          className="mb-3 position-relative"
          controlId="formBasicUserName">
          <Form.Control
            type={"file"}
            placeholder={"Select file"}
            name={"txnImage"}
            onChange={(e) => handleChange(e, "file")}
            // style={{ display: !field.display ? "none" : "" }}
            isInvalid={!!errors["txnImage"]}
          />
          <Form.Control.Feedback type="invalid">
            {errors["txnImage"]}
          </Form.Control.Feedback>
        </Form.Group>
        <Button
          className="px-5 mb-4"
          variant="primary"
          onClick={handleSubmit}
          style={{ fontSize: "15px", width: "auto", borderRadius: "3px" }}
          disabled={isCreatingDeposit}>
          {isCreatingDeposit ? "Submitting" : "Submit"}
        </Button>
      </Form>
    );
  };

  const renderCustomActionResponse = () => {
    if (customdepositResponseType === CUSTOM_DEPOSIT_RESPONSE_TYPE.IMAGE) {
      return (
        <div>
          <div className="ml-4 ">
            <div className="bg-zinc-50 rounded-lg p-3 qrSize">
              <img src={customActionDepositResponse} />
            </div>
          </div>
        </div>
      );
    } else if (
      customdepositResponseType === CUSTOM_DEPOSIT_RESPONSE_TYPE.QRCODE
    ) {
      return (
        <div>
          <QRCodeCard text={customActionDepositResponse} />
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      {!activeGtw && <HeaderAfterLogin />}

      {customActionDepositResponse && customdepositResponseType ? (
        <>
          <div className="HpaySection">
            <div
              className="HayQR"
              onClick={() => {
                setCustomActionDepositResponse(null);
                setCustomDepositResponseType(null);
              }}>
              <img src={CrossBtn} alt="CrossBtn" />
            </div>
            {renderCustomActionResponse()}
          </div>
        </>
      ) : (
        <main className="main">
          <div className="d-xl-none mt--14">
            {!activeGtw && <LeftBarSports />}
          </div>

          {!isBank ? (
            <Container>
              <DisplayValues
                displayItems={selectedGateway?.depositDisplayFields || []}
                selectedGateway={selectedGateway?.id}
              />
              {!activeGtw && (
                <div className="headingSec">
                  <h4>{selectedGateway?.name}</h4>
                  <div className="back-link" onClick={() => navigate(-1)}>
                    <BackIcon /> Back
                  </div>
                </div>
              )}
              {selectedGateway?.type === "manual" &&
                selectedGateway?.url !== "/deposit/pay/dynamicmanual" && (
                  <>
                    <div className="valuesDeposit">
                      {/* <h3>Wallet : {selectedGateway?.value}</h3> */}
                      <h3>UPI : {selectedGateway?.displayValue}</h3>

                      <div className="copyValue">
                        <CopyToClipboard
                          text={selectedGateway?.displayValue}
                          onCopy={() => {
                            Toaster(
                              APP_CONST.TOAST_TYPE.SUCCESS,
                              "Text Copied",
                            );
                          }}>
                          <div className="CopyUPIContent">
                            <div>Click to copy code</div>
                            <AiFillCopy />
                          </div>
                        </CopyToClipboard>
                      </div>
                    </div>
                    {(selectedGateway?.showQr === true && (
                      <div className="d-flex">
                        {showQrImg ? (
                          <div className=" mx-auto  w-full max-w-[12rem]  relative">
                            <div className="ml-4 ">
                              <div className="bg-zinc-50 rounded-lg p-3 qrSize">
                                <img src={selectedGateway?.qrCode} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <QRCodeCard text={selectedGateway?.value} />
                        )}
                      </div>
                    )) ||
                      null}
                  </>
                )}
              <Form className="gatewayForm">
                {selectedGateway?.fields?.map((f, i) => {
                  return renderFields(f);
                })}
                <Button
                  className={
                    selectedGateway?.type === "auto" ? "next-btn" : "px-4 mb-4"
                  }
                  onClick={handleSubmit}
                  style={{
                    fontSize: "15px",
                    width: "auto",
                    borderRadius: "3px",
                  }}
                  disabled={isCreatingDeposit}>
                  {isCreatingDeposit ? "Loading.." : "Submit"}
                </Button>
                <ul className="notes">
                  {/* <li>
                    We cover your 4.5% crypto processing fee by adding it back
                    to your account as a cash bonus instantly — no wagering
                    required.
                  </li> */}
                  {/* <li>
                    We cover your 1%- 4.5% crypto processing fee by adding it
                    back to your account as a cash bonus instantly — no wagering
                    required.
                  </li> */}
                </ul>
                {selectedGateway?.type === "auto" && (
                  <div className="info-text">
                    <p className="note">
                      <span>Note:</span> In case you face any issue with payment
                      method or amount is not credit to your account contact us
                      immediately through the <b>live chat</b> or{" "}
                      <b>whatsapp</b>
                    </p>

                    <ul className="contact">
                      <li>
                        <a
                          className="wtsp"
                          href={
                            appDetails?.WHATS_APP_URL != ""
                              ? `https://wa.me/${phone}`
                              : "#"
                          }
                          target={
                            appDetails?.WHATS_APP_URL != "" ? "_blank" : ""
                          }>
                          Whatsapp
                        </a>
                      </li>
                    </ul>

                    {/* <a
                      className="back-link depositVideo mt-3 mb-4"
                      href="https://youtube.com/shorts/-x5n958LpE0?si=bLEpSNtgZQhhBjm6"
                      target="_blank"
                    >
                      <img
                        src={Youtube}
                        alt="Youtube"
                        style={{ width: "24px", marginRight: "8px" }}
                      />{" "}
                      How to make deposit
                    </a> */}
                  </div>
                )}
              </Form>
            </Container>
          ) : (
            <Container>
              <div className="headingSec">
                {"Bank Transfer"}
                <div className="back-link" onClick={() => navigate(-1)}>
                  <BackIcon /> Back
                </div>
              </div>
              {bankDetails && (
                <div className="dpst-bank-dtls mb-4">
                  <p>
                    Account name : {bankDetails?.acc_name}{" "}
                    <CopyToClipboard
                      text={bankDetails?.acc_name}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}>
                      <AiFillCopy />
                    </CopyToClipboard>
                  </p>
                  <p>
                    Account number : {bankDetails?.acc_no}{" "}
                    <CopyToClipboard
                      text={bankDetails?.acc_no}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}>
                      <AiFillCopy />
                    </CopyToClipboard>
                  </p>
                  <p>
                    IFSC code : {bankDetails?.ifsc_code}{" "}
                    <CopyToClipboard
                      text={bankDetails?.ifsc_code}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}>
                      <AiFillCopy />
                    </CopyToClipboard>
                  </p>
                  <p className="mb-0">
                    Bank name : {bankDetails?.bank_name}{" "}
                    <CopyToClipboard
                      text={bankDetails?.bank_name}
                      onCopy={() => {
                        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Text Copied");
                      }}>
                      <AiFillCopy />
                    </CopyToClipboard>
                  </p>
                </div>
              )}
              {bankDetails && renderBankTransferForm()}
            </Container>
          )}
        </main>
      )}

      {!activeGtw && <Footer />}
    </>
  );
};
export default DepositGateway;
